<template>
  <v-system-bar> <slot /> </v-system-bar>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CardTitle",
  props: ["title", "color"],
  data() {
    return {};
  },
});
</script>
